import { useState, useEffect, useCallback } from "react";

type ToastType = "success" | "error" | "info";

interface Toast {
  id: number;
  message: string;
  type: ToastType;
}

let nextId = 0;
let toasts: Toast[] = [];
let listener: (() => void) | null = null;

export function showToast(message: string, type: ToastType = "info"): void {
  const id = nextId++;
  toasts = [...toasts, { id, message, type }];
  // Enforce max 3 visible — drop oldest
  if (toasts.length > 3) {
    toasts = toasts.slice(toasts.length - 3);
  }
  listener?.();

  // Auto-dismiss after 3s
  setTimeout(() => {
    toasts = toasts.filter((t) => t.id !== id);
    listener?.();
  }, 3000);
}

export function ToastContainer() {
  const [, setTick] = useState(0);

  const rerender = useCallback(() => setTick((t) => t + 1), []);

  useEffect(() => {
    listener = rerender;
    return () => {
      listener = null;
    };
  }, [rerender]);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast--${t.type}`}>
          {t.message}
        </div>
      ))}
    </div>
  );
}
